import { render, staticRenderFns } from "./child_searchBar.vue?vue&type=template&id=2128093c&scoped=true"
import script from "./child_searchBar.vue?vue&type=script&lang=js"
export * from "./child_searchBar.vue?vue&type=script&lang=js"
import style0 from "./child_searchBar.vue?vue&type=style&index=0&id=2128093c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2128093c",
  null
  
)

export default component.exports